import _Typography from "@mui/material/Typography";
import _Box from "@mui/material/Box";
import React from 'react';
export const podiumRanksConfig = {
  1: {
    avatarSize: 88,
    avatarTop: -44,
    background: 'linear-gradient(180deg, #FFE27D 0%, #FFB48B 100%)',
    badgeBgColor: '#FFECA9',
    badgeBorderColor: '#EBAF25',
    badgeTextColor: '#BB8A1A',
    minHeight: 203,
    paddingBottom: 54,
    ringColor: '#FFE27D'
  },
  2: {
    avatarSize: 72,
    avatarTop: -36,
    background: 'linear-gradient(151deg, #DDE0E7 0%, #9CBDF4 76.356%)',
    badgeBgColor: '#D9E7FF',
    badgeBorderColor: '#9CBDF4',
    badgeTextColor: '#326AC2',
    minHeight: 182,
    paddingBottom: 43,
    ringColor: '#9CBDF4'
  },
  3: {
    avatarSize: 72,
    avatarTop: -36,
    background: 'linear-gradient(180deg, #FFB48B 0%, #FFA3A3 100%)',
    badgeBgColor: '#FFDCC1',
    badgeBorderColor: '#FA823E',
    badgeTextColor: '#C14F0E',
    minHeight: 154,
    opacity: 0.9,
    paddingBottom: 24,
    ringColor: '#FFB48B'
  }
};

// Left-to-right display order: 2nd, 1st (tallest, center), 3rd.
export const podiumOrder = [{
  itemIndex: 1,
  rank: 2
}, {
  itemIndex: 0,
  rank: 1
}, {
  itemIndex: 2,
  rank: 3
}];
function PodiumCard({
  avatar,
  children,
  rank
}) {
  const config = podiumRanksConfig[rank];
  return /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flex: "1 1 0",
    flexDirection: "column",
    justifyContent: "flex-end",
    marginTop: "56px",
    minHeight: config.minHeight,
    minWidth: 0,
    paddingBottom: `${config.paddingBottom}px`,
    paddingTop: 3,
    paddingX: 3,
    position: "relative",
    sx: {
      background: config.background,
      borderRadius: 4,
      boxSizing: 'border-box',
      opacity: config.opacity
    }
  }, /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    left: "50%",
    position: "absolute",
    sx: {
      transform: 'translateX(-50%)'
    },
    top: config.avatarTop
  }, /*#__PURE__*/React.createElement(_Box, {
    bgcolor: "#fff",
    border: `2px solid ${config.ringColor}`,
    borderRadius: "50%",
    display: "inline-flex",
    padding: "2px",
    sx: {
      boxSizing: 'border-box'
    }
  }, avatar ?? /*#__PURE__*/React.createElement(_Box, {
    bgcolor: "#fff",
    borderRadius: "50%",
    height: config.avatarSize,
    width: config.avatarSize
  })), /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    bgcolor: config.badgeBgColor,
    border: `2px solid ${config.badgeBorderColor}`,
    borderRadius: "50%",
    display: "flex",
    height: 40,
    justifyContent: "center",
    marginTop: "-16px",
    marginX: "auto",
    position: "relative",
    sx: {
      boxSizing: 'border-box'
    },
    width: 40,
    zIndex: 1
  }, /*#__PURE__*/React.createElement(_Typography, {
    color: config.badgeTextColor,
    fontWeight: 700,
    variant: "body1"
  }, rank))), /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    gap: 0.5,
    sx: {
      '& .MuiTypography-root': {
        textAlign: 'center'
      }
    }
  }, children));
}
export default PodiumCard;